
import { Vue, Component, Prop } from "vue-property-decorator";
import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";
import GET_CONTRACTOR_ACTIVITIES from "@/apollo/projectActivities/GetContractorActivities.gql";

import CardPagination from "@/components/card/PaginationNew.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { Project } from "@/interface";
import ProjectActivityForm from "@/entities/ProjectActivityForm";
import paginationConfig from "@/data/paginationConfig";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import ContractorActivityCard from "@/components/projects/activities/ContractorActivityCardNew.vue";

@Component({
  components: {
    ContractorActivityCard,
    EmptyListPlaceholder,
    CardPagination,
    LoadingOverlay,
    EmptyListImageContractors,
  },
  apollo: {
    activities: {
      query: GET_CONTRACTOR_ACTIVITIES,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project_activity.length;
        return data.project_activity;
      },
    },
  },
})
export default class Activities extends Vue {
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;

  activities?: ProjectActivityForm[] = undefined;
  paginationConfig: PaginationConfig = { ...paginationConfig };

  get empty(): boolean {
    if (!this.activities) {
      return false;
    }

    return this.activities.length === 0;
  }

  get activitiesArgs(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      offset: nextOffset,
      limit,
      where: {
        project_id: { _eq: this.$route.params.id },
        drafted: { _eq: false },
        deleted: { _eq: false },
        contractor: {
          user: {
            id: {
              _eq: this.currentUserId,
            },
          },
        },
      },
    };
  }
}
